import { render } from "./ReplyView.vue?vue&type=template&id=162295d5"
import script from "./ReplyView.vue?vue&type=script&lang=js"
export * from "./ReplyView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__